import Application from "./application/Application";
import ClientModule from './client-module/ClientModuleConfiguration';
import Demo from './demo/DemoSettings';
import DigitalDeliveryTemplate from './digital-delivery-template';
import License from "./license/License";
import DigitalDeliveryErrors from './logs/DigitalDeliveryErrors';
import Logs from './logs/Logs';
import Notification from "./notification/Notifications";
import User from './user/UserSettings';

export default { Application, License, Notification, Demo, User, DigitalDeliveryTemplate, ClientModule, Logs, DigitalDeliveryErrors };
